import { useContext } from "react";
import { SanityNode } from "../config/build/models/node";
import { PageContext } from "../context/PageContext";
import { SiteSettingsContext } from "../context/SiteSettingsContext";
import { isNullOrWhiteSpace } from "../shared/string";

export const useParentNode = (node: SanityNode | undefined) => {
  let parentNode: SanityNode | undefined;
  const { i18nLang } = useContext(PageContext);
  const { routeInfo } = useContext(SiteSettingsContext);

  if (node) {
    switch (node._type) {
      case "pressRelease":
        if (!isNullOrWhiteSpace(routeInfo?.pressReleaseList?.slug?.current)) {
          parentNode = {
            title: routeInfo!.pressReleaseList!.title,
            slug: {
              current: routeInfo!.pressReleaseList!.slug!.current
            },
            i18nLang: i18nLang
          };
        }
        break;
      case "blogArticle":
        if (!isNullOrWhiteSpace(routeInfo?.blogList?.slug?.current)) {
          parentNode = {
            title: routeInfo!.blogList!.title,
            slug: {
              current: routeInfo!.blogList!.slug!.current
            },
            i18nLang: i18nLang
          };
        }
        break;
      default:
        parentNode = node.parentLink ? node.parentLink : node._rawParentLink;
    }
  }

  return parentNode;
};
